
import { mapState, mapMutations } from "vuex";

export default {
	name: 'overlay',

	components: {
	},

	filters: {

	},


	data() {
		return {
			isShow: false

		};
	},
	watch: {
	},
	computed: {
		...mapState(["user"]),




	},
	created() {
	},


	beforeDestroy() {
	},

	methods: {
		...mapMutations([
		]),
		show() {
			this.isShow = true;
			// setTimeout(this.hide, this.duration);
		},
		hide() {
			this.isShow = false;	
			// this.remove();
		}
	}


}
